module.exports = __webpack_public_path__ + "static/media/imagefile.9e837480.svg";